






import { mixins } from 'vue-class-component'
import { Vue, Component } from 'vue-property-decorator'

import '@/classComponentHooks.ts'

import '../node_modules/nprogress/nprogress.css'
import '@/styles/icons.scss'
import '@/styles/element-theme/base.scss'
import UiScreenTypeMixin from '@/mixins/UiScreenTypeMixin.vue'

@Component
export default class App extends mixins(UiScreenTypeMixin, Vue) {
  currentAppName(): string {
    return process.env.VUE_APP_APPLICATION_NAME || 'sailcrm'
  }
}
